import { useEffect, useState } from 'react';

/**
 * One object URL per file, revoked when the file changes or the component
 * unmounts. Calling URL.createObjectURL during render made a new blob URL
 * on every keystroke and never released any of them.
 */
export const useObjectUrl = (file?: Blob): string | undefined => {
  const [url, setUrl] = useState<string>();
  useEffect(() => {
    if (!file) {
      setUrl(undefined);
      return;
    }
    const next = URL.createObjectURL(file);
    setUrl(next);
    return () => URL.revokeObjectURL(next);
  }, [file]);
  return url;
};
